<template>
  <FormulateForm
    :name="formName"
    v-model="formValues"
    @submit="submit"
    class="bg-gray-100 py-4 px-6"
  >
    <h3 v-if="!edit" class="font-bold text-xl mb-4">
      New client
    </h3>

    <div class="flex items-start mb-4">
      <div class="flex-1 mr-8">
        <FormulateInput
          name="name"
          type="text"
          label="Name"
          placeholder="Name"
          validation="required"
        />
        <FormulateInput
          name="username"
          type="text"
          label="Username"
          placeholder="Username"
          validation="required"
        />
        <FormulateInput
          name="shared_secret"
          type="text"
          label="Shared secret"
          placeholder="Shared secret"
          validation="required"
        />
      </div>
      <admin-export-targets
        v-if="edit"
        :clientId="client.id"
        :targets="targets"
        class="flex-1"
      />
    </div>

    <FormulateErrors />

    <base-button type="submit" :loading="sending">
      {{ edit ? 'Save' : 'Create' }}
    </base-button>
  </FormulateForm>
</template>

<script>
import { mapState } from 'vuex';
import AdminExportTargets from './AdminExportTargets.vue';

export default {
  components: { AdminExportTargets },
  props: {
    client: Object,
    targets: Array,
  },
  data() {
    return {
      formName: `exportClient${this.client ? this.client.id : ''}`,
      formValues: this.client || {},
      sending: false,
    };
  },
  computed: {
    ...mapState({
      currentCompanyId: (state) => state.company.currentId,
    }),
    edit() {
      return Boolean(this.client);
    },
  },
  methods: {
    async submit(data) {
      try {
        this.sending = true;
        this.$formulate.resetValidation(this.formName);
        if (this.edit) {
          await this.$store.dispatch('company/exports/updateClient', data);
        } else {
          await this.$store.dispatch('company/exports/addClient', data);
        }
        this.$emit('saved');
      } catch (error) {
        this.$formulate.handle(error, this.formName);
      } finally {
        this.sending = false;
      }
    },
  },
};
</script>
